import { observer } from "mobx-react";
import React from "react";

import { NavLink } from "react-router-dom";

import { AccountVerificationStatus } from "@api-types/user/LoginResponseDto";
import { useRootAppStore } from "@hooks";
import { THEME_SETTINGS } from "@theme-settings";
import classNames from "classnames";

export default observer(function AccountVerificationItem(props: {
	path: string;
	translation: string;
}) {
	const rootStore = useRootAppStore();

	return (
		<li className="nav--tertiary__item">
			<NavLink
				to={props.path}
				className="nav--tertiary__link"
				activeClassName="is-active"
				isActive={(_, location) =>
					location.pathname.includes(props.path)
				}
			>
				<span className="nav--tertiary__title">
					{props.translation}
				</span>

				{THEME_SETTINGS.isAccountVerificationSectionEnabled ? (
					<i
						className={classNames("u-icon u-icon--sml", {
							"u-icon--alert-circle--bold u-color--sent--warning":
								rootStore.userAuthStore.onlineUser
									?.accountVerificationStatus !==
								AccountVerificationStatus.FullyVerified,
							"u-icon--check-circle--bold u-color--sent--success":
								rootStore.userAuthStore.onlineUser
									?.accountVerificationStatus ==
								AccountVerificationStatus.FullyVerified,
						})}
					/>
				) : null}
			</NavLink>
		</li>
	);
});
